import { Stack } from 'react-bootstrap';
import { faRotate } from '@fortawesome/free-solid-svg-icons';

import IconButton from '@components/Button/IconButton';
import { SUPPORT_EMAIL } from '@constants/constants';

interface RequisitionsErrorOverlayProps {
  error: string;
  onRetry: () => void;
}

export const RequisitionsErrorOverlay: React.FC<RequisitionsErrorOverlayProps> = props => (
  <div className='requisitions-status-panel'>
    <Stack gap={3}>
      <h5 className='fs-5 lh-sm fw-medium'>Unable to load requisition data</h5>

      <div className='lh-base fs-6'>
        <p>Please retry or return later.</p>

        <div>
          If the problem recurs, please contact <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.
        </div>

        <div>We’re sorry for the inconvenience.</div>

        <small className='d-inline-block fs-sm fw-bold my-2'>500: Internal Server Error</small>
      </div>

      <IconButton
        startIcon={faRotate}
        className='align-self-center'
        variant='primary'
        size='lg'
        onClick={props.onRetry}
      >
        Retry
      </IconButton>
    </Stack>
  </div>
);
